// src/components/MapComponent.tsx
import React from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css'; // Still need Leaflet's own CSS

// **IMPORTANT:** If you encounter marker icon issues with your bundler,
// uncomment and use this block. This is often needed when bundlers
// don't correctly process Leaflet's default icon paths.
// import L from 'leaflet';
// delete (L.Icon.Default.prototype as any)._getIconUrl;
// L.Icon.Default.mergeOptions({
//   iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
//   iconUrl: require('leaflet/dist/images/marker-icon.png'),
//   shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
// });
interface MapperProps {
    markers?: Array<{
        position: [number, number];
        popupTitle?: string;
        popupContent?: string;
    }>;
    zoom?: number;
    center?: [number, number]; // Optional center prop to allow dynamic centering
}

export const Mapper: React.FC<MapperProps> = ({
    markers = [],
    zoom = 13,
    center = [51.505, -0.09],
}) => {
    return (
        // 1. Using Tailwind for the MapContainer wrapper (e.g., height, width, border, shadow)
        // We'll replace the inline style with Tailwind classes.
        // Note: React-Leaflet's MapContainer needs its height to be defined.
        // Using a specific utility class like 'h-[500px]' or a defined height class.
        <MapContainer
            center={center}
            zoom={zoom}
            scrollWheelZoom={false}
            // Apply Tailwind classes directly here
            // For height, you can use h-full if a parent has a defined height,
            // or a specific height like h-[500px] or h-96.
            // Here, we'll use a specific height for simplicity.
            className="h-43 w-full border border-mp-border"
        >
            {/* TileLayer remains the same */}
            <TileLayer
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            {markers.map((marker, index) => (
                <Marker key={index} position={marker.position}>
                    <Popup>
                        <h3 className="text-lg font-bold mb-1">{marker.popupTitle}</h3>
                        <p className="text-sm">{marker.popupContent}</p>
                    </Popup>
                </Marker>
            ))}
        </MapContainer>
    );
};
